'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBookingComponent;

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _React = require('React');

var _React2 = _interopRequireDefault(_React);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _reactRedux = require('react-redux');

var _AppContainer = require('./AppContainer');

var _AppContainer2 = _interopRequireDefault(_AppContainer);

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _FormState = require('MeetingsLib/models/FormState');

var _FormState2 = _interopRequireDefault(_FormState);

var _TrackingParams = require('MeetingsLib/models/TrackingParams');

var _TrackingParams2 = _interopRequireDefault(_TrackingParams);

var _createStore = require('MeetingsLib/utils/createStore');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createBookingComponent(_ref) {
  var _ref$httpClient = _ref.httpClient,
      httpClient = _ref$httpClient === undefined ? _apiClient2.default : _ref$httpClient,
      _ref$embedded = _ref.embedded,
      embedded = _ref$embedded === undefined ? true : _ref$embedded,
      slug = _ref.slug,
      _ref$formState = _ref.formState,
      formState = _ref$formState === undefined ? {} : _ref$formState,
      forceOffline = _ref.forceOffline,
      _ref$timezone = _ref.timezone,
      timezone = _ref$timezone === undefined ? _I18n2.default.moment.tz.guess() : _ref$timezone,
      _ref$initTrackingForM = _ref.initTrackingForMeetings,
      initTrackingForMeetings = _ref$initTrackingForM === undefined ? true : _ref$initTrackingForM,
      _ref$trackingParams = _ref.trackingParams,
      trackingParams = _ref$trackingParams === undefined ? {} : _ref$trackingParams,
      onSuccess = _ref.onSuccess,
      locale = _ref.locale,
      forceMobile = _ref.forceMobile,
      _ref$parentPageHSAnal = _ref.parentPageHSAnalyticsInfo,
      parentPageHSAnalyticsInfo = _ref$parentPageHSAnal === undefined ? {} : _ref$parentPageHSAnal,
      _ref$troubleshooting = _ref.troubleshooting,
      troubleshooting = _ref$troubleshooting === undefined ? false : _ref$troubleshooting;

  var formStateFromParams = _FormState2.default.from(formState);
  var paramsHaveNoValues = _immutable2.default.is(formStateFromParams, new _FormState2.default());

  var store = (0, _createStore.createStore)({
    userSlug: slug,
    embedded: embedded,
    forceOffline: forceOffline,
    trackingParams: new _TrackingParams2.default(trackingParams),
    formState: paramsHaveNoValues ? null : formStateFromParams,
    stagedFormState: formStateFromParams,
    currentTime: _I18n2.default.moment().valueOf(),
    userTimezone: timezone,
    initTrackingForMeetings: initTrackingForMeetings,
    onSuccess: onSuccess,
    localeFromProps: locale,
    forceMobile: forceMobile,
    parentPageHSAnalyticsInfo: parentPageHSAnalyticsInfo,
    troubleshooting: troubleshooting
  }, httpClient);

  return function (props) {
    return _React2.default.createElement(
      _reactRedux.Provider,
      { store: store },
      _React2.default.createElement(_AppContainer2.default, props)
    );
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/createBookingComponent.js
// module id = 279
// module chunks = 0